/* eslint-disable no-plusplus */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-empty */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';

import {
  getCategoriesAction, getCsvCategoriesReport, removeCategoryAction, updateCategoriesAction, updateCategoryAction,
  updateCategoryStatus,
} from '../app/store/actions/categories';
import { disableProductsByCategory } from '../app/store/actions/products';
import Select from '../components/form/select';
import ModalComponent from '../components/modal';
import Notification from '../components/notifications';
import ROUTES from '../data/routes';

class CategoryPage extends Component {
  constructor(props) {
    super(props);

    this.categoryNameState = 'categoryOrder';
    this.arrCatOrders = [1, 2, 3, 4, 5];

    this.state = {
      show: false,
      message: '',
      classe: '',
      showModal: false,
      selectedItem: '',
      titleModal: '',
      bodyModal: '',
      titleOkButtoonModal: '',
      widthModal: '',
      heightModal: '',
      idModal: '',
      showCancel: true,
      showModalFeatured: false,
      orders: {},
      categoryName: I18n.t('selectCategory'),
      ordersRequiredError: false,
      showChangeCategoryStatusModal: false,
      alterId: '',
      alterisActive: '',
      alterName: '',
    };
  }

  componentDidMount() {
    this.props.getCategories();
  }

  showCategory = async (id) => {
    const div = await document.getElementById(id);
    const style = await div.style.display;
    if (style && style === 'none') {
      div.style.display = 'block';
    } else if (style && style === 'block') {
      div.style.display = 'none';
    } else {
      document.getElementById(id).style.display = 'block';
    }
  }

  notification = (classe, message) => {
    this.setState({ show: true, message, classe });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  removeCategory = async (id) => {
    this.setState({
      idModal: false,
      showModal: true,
      selectedItem: false,
      titleModal: I18n.t('delete'),
      bodyModal: I18n.t('deleteCategoryModal'),
      titleOkButtoonModal: I18n.t('confirm'),
      widthModal: '300px',
      heightModal: '170px',
      showCancel: true,
      removeId: id,
    });
  }

  updateCategory = (category, parent) => {
    this.props.history.push({
      pathname: ROUTES.FORM,
      category,
      parent,
      screenComming: 'category',
    });
  }

  changeCategoryStatus = async (id, isActive, name) => {
    const { companyTag } = this.props.settings;

    try {
      if (companyTag === 'nortel') {
        if (isActive) {
          await this.setState({
            showChangeCategoryStatusModal: true,
            idModal: false,
            selectedItem: false,
            titleModal: I18n.t('changeStatus'),
            bodyModal: I18n.t('changeCategoryStatusModal', { 0: name }),
            titleOkButtoonModal: I18n.t('confirm'),
            widthModal: '450px',
            heightModal: '215px',
            showCancel: true,
            alterId: id,
            alterisActive: isActive,
            alterName: name,
          });
        } else {
          await this.setState({
            alterId: id,
            alterisActive: isActive,
            alterName: name,
          });

          await this.onChangeCategoryStatusConfirm();
        }
      } else {
        await this.props.updateCategory({ id, isActive: !isActive });
        await this.props.getCategories();
      }
    } catch (error) {
      if (error && error.response) this.notification('danger', error.response.message);
      else this.notification('danger', I18n.t('errorCategory'));
    }
  }

  onChangeCategoryStatusConfirm = async () => {
    const { alterId, alterisActive, alterName } = this.state;
    let productResult = '';

    await this.setState({ showChangeCategoryStatusModal: false });

    try {
      if (alterisActive) productResult = await this.props.disableProductsByCategory(alterId);
      await this.props.updateCategoryStatus(alterId);

      if (alterisActive) {
        this.notification(
          'success',
          `${I18n.t(
            'successCategory',
            { 0: alterName, 1: productResult.totalProductsDisabled ? productResult.totalProductsDisabled : 0 },
          )}`,
        );
      } else {
        this.notification('success', `${I18n.t('showCategoryName', { 0: alterName })}`);
      }

      await this.props.getCategories();
    } catch (error) {
      if (error && error.response) this.notification('danger', error.response.message);
      else this.notification('danger', I18n.t('errorCategory'));
    }
  }

  onModalConfirm = async () => {
    const { removeId } = this.state;
    this.setState({ showModal: false });
    try {
      await this.props.removeCategory(removeId);
      this.notification('success', I18n.t('categoryDeleted'));
      await this.props.getCategories();
    } catch (err) {
      this.notification('danger', I18n.t('categoryHasNotChild'));
    }
  }

  onSaveOrders = async () => {
    try {
      const { orders = {} } = this.state;

      const ordersKeys = Object.keys(orders);

      if (ordersKeys.length !== this.arrCatOrders.length) {
        this.setState({ ordersRequiredError: true });
        return;
      }

      await this.props.updateCategories({
        categories: ordersKeys.map(orderIdKey => ({ id: orders[orderIdKey].value, order: parseInt(orderIdKey, 10) })),
      });

      this.props.getCategories();
      this.setState({ ordersRequiredError: false, showModalOrderCategory: false });
    } catch (e) { }
  }

  setCategoryOrder = (id, optionValue = {}) => {
    const { label, value } = optionValue || {};
    if (value) {
      const newValues = Object.keys(this.state.orders).reduce((acum, keyValue) => {
        if (id !== keyValue && this.state.orders[keyValue].value === value) return acum;
        acum[keyValue] = this.state.orders[keyValue];
        return acum;
      }, {});
      this.setState({
        orders: {
          ...newValues, [id]: { label, value },
        },
        ordersRequiredError: false,
      });
    } else {
      const newStateOrders = { ...this.state.orders };
      delete newStateOrders[id];

      this.setState({
        orders: newStateOrders,
        ordersRequiredError: false,
      });
    }
  }

  showOrdersCategoryModal = () => {
    const { categories = [] } = this.props;
    let ordersInAcum = 0;
    const maxOrders = this.arrCatOrders.length;
    const orders = categories.reduce((acum, category) => {
      if (ordersInAcum < maxOrders) {
        const orderId = parseInt(category.order, 10);
        if (orderId) {
          acum[orderId] = { label: category.name, value: category.id };
          ordersInAcum++;
        }

        if (category.categories) {
          category.categories.forEach((subCategory) => {
            if (ordersInAcum < maxOrders) {
              const orderIdSub = parseInt(subCategory.order, 10);
              if (orderIdSub) {
                acum[orderIdSub] = { label: subCategory.name, value: subCategory.id };
                ordersInAcum++;
              }
            }
          });
        }
      }

      return acum;
    }, {});

    this.setState({
      showModalOrderCategory: true,
      ordersRequiredError: false,
      orders,
    });
  }

  getOptionsCategories = (categories = []) => {
    const optionsEl = [];
    categories.forEach((category) => {
      optionsEl.push({
        label: `${category.id} - ${category.name}`,
        value: category.id,
      });

      if (category.categories) {
        category.categories.forEach((subCategory) => {
          optionsEl.push({
            label: `---- ${subCategory.id} - ${subCategory.name}`,
            value: subCategory.id,
          });
        });
      }
    });

    return optionsEl;
  };

  renderOrdersCategory = categories => (
    <div className="form-main">
      <h4>{I18n.t('categoryShopBottomMenu')}</h4>
      <form>
        {
          this.arrCatOrders.map(orderId => (
            <div key={orderId} className="form-group">
              <p className="margin-bottom-2">
                {`${orderId}ª `}
                <Translate value="category" />
              </p>
              <Select
                value={this.state.orders[orderId] || ''}
                onChange={value => this.setCategoryOrder(orderId, value)}
                options={categories ? this.getOptionsCategories(categories) : []}
                isClearable
                placeholder={this.state.categoryName}
              />
              <div className="invalid-feedback"><Translate value="selectBrand" /></div>
            </div>
          ))
        }
        {this.state.ordersRequiredError && (<p style={{ color: 'red' }}><Translate value="uploadUserText4" /></p>)}
        <div className="text-align-modal">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => this.setState({ showModalOrderCategory: false })}
          >
            <Translate value="cancel" />
          </button>
          <button
            type="button"
            className="btn btn-primary margin-left-btn-modal"
            onClick={this.onSaveOrders}
          >
            <Translate value="save" />
          </button>
        </div>
      </form>
    </div>
  )

  getCategories = categories => categories.map((category) => {
    const totalProd = parseInt(category.totalProd, 10);
    const totalProdValid = Number.isNaN(totalProd) ? 0 : totalProd;

    return (
      <div key={category.id}>
        <div style={{ display: 'flex' }}>
          <div className="width-100p main-category-page" style={{ flex: 26 }}>
            <button
              onClick={() => this.showCategory(`main${category.id}`)}
              type="button"
              className="btn-not-styled cursor-pointer"
            >
              {category.categories && category.categories.length > 0 && <i className="fas fa-plus" />}
              {`${category.id} - ${category.name}`}
            </button>
            <div className="btn-group" role="group" aria-label="Button group with nested dropdown width-100p" style={{ justifyContent: 'space-between' }}>
              {this.props.settings.companyTag == 'chile'
                && (
                  <div style={{
                    marginRight: 20, display: 'flex', alignItems: 'center', width: '140px', float: 'left',
                  }}
                  >
                    {`${I18n.t('total')} ${I18n.t('products')}: ${totalProdValid}`}
                  </div>
                )}
              <div className="btn-group" role="group" aria-label="Button group with nested dropdown width-100p" style={{ justifyContent: 'flex-end', width: '200px' }}>
                <button
                  type="button"
                  className={`category-toggle-son btn btn-${category.isActive ? 'warning' : 'dark'} promotion-btn-${category.isActive ? 'warning' : 'active'}`}
                  style={{ marginRight: 8, borderWidth: 0 }}
                  onClick={() => this.changeCategoryStatus(category.id, category.isActive, category.name)}
                >
                  <Translate value={category.isActive ? 'disable' : 'active'} />
                </button>
                <div className="btn-group" role="group">
                  <button
                    id="btnGroupDrop1"
                    type="button"
                    className="btn btn-dark dropdown-toggle category-toggle-son"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <Translate value="action" />
                  </button>
                  <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <button
                      type="button"
                      className="dropdown-item dropdown-table"
                      onClick={() => this.updateCategory(category)}
                    >
                      <Translate value="edit" />
                    </button>
                    <button
                      type="button"
                      className="dropdown-item dropdown-table"
                      onClick={() => this.removeCategory(category.id)}
                    >
                      <Translate value="delete" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id={`main${category.id}`} className="display-none">
          {category.categories
            && category.categories.map((subCategory) => {
              const totalSubCategory = parseInt(subCategory.totalProd, 10);
              const totalSubCategoryValid = Number.isNaN(totalSubCategory) ? 0 : totalSubCategory;
              return (
                <div key={subCategory.id}>
                  <div style={{ display: 'flex' }}>
                    <div className="main-category-page2" style={{ flex: 26, marginLeft: 'unset' }}>
                      <button
                        onClick={() => this.showCategory(`sub${subCategory.id}`)}
                        type="button"
                        className="btn-not-styled cursor-pointer"
                      >
                        {subCategory.categories && <i className="fas fa-plus" />}
                        {`${subCategory.id} - ${subCategory.name}`}
                      </button>
                      <div className="btn-group" role="group" aria-label="Button group with nested dropdown width-100p" style={{ justifyContent: 'space-between' }}>
                        {this.props.settings.companyTag == 'chile'
                          && (
                            <div style={{
                              marginRight: 20, display: 'flex', alignItems: 'center', width: '130px', float: 'left',
                            }}
                            >
                              {`${I18n.t('total')} ${I18n.t('products')}: ${totalSubCategoryValid}`}
                            </div>
                          )}
                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown width-100p" style={{ justifyContent: 'flex-end', width: '200px' }}>
                          <button
                            type="button"
                            className={`category-toggle-son btn btn-${subCategory.isActive ? 'warning' : 'dark'} promotion-btn-${subCategory.isActive ? 'warning' : 'active'}`}
                            style={{ marginRight: 8, borderWidth: 0 }}
                            onClick={() => this.changeCategoryStatus(subCategory.id, subCategory.isActive, subCategory.name)}
                          >
                            <Translate value={subCategory.isActive ? 'disable' : 'active'} />
                          </button>
                          <div className="btn-group" role="group">
                            <button
                              id="btnGroupDrop1"
                              type="button"
                              className="btn btn-warning dropdown-toggle category-toggle-son2"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <Translate value="action" />
                            </button>
                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                              <button
                                type="button"
                                className="dropdown-item dropdown-table"
                                onClick={() => this.updateCategory(subCategory, category)}
                              >
                                <Translate value="edit" />
                              </button>
                              <button
                                type="button"
                                className="dropdown-item dropdown-table"
                                onClick={() => this.removeCategory(subCategory.id)}
                              >
                                <Translate value="delete" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id={`sub${subCategory.id}`} className="display-none">
                    {subCategory.categories && subCategory.categories.map(sub => (
                      <div key={sub.id}>
                        <div className="main-category-page3">
                          <button
                            onClick={() => this.showCategory(`sub2${sub.id}`)}
                            type="button"
                            className="btn-not-styled cursor-pointer"
                          >
                            {`${sub.id} - ${sub.name}`}
                          </button>
                          <div className="btn-group" role="group" aria-label="Button group with nested dropdown width-100p">
                            <div className="btn-group" role="group">
                              <button
                                id="btnGroupDrop1"
                                type="button"
                                className="btn btn-secondary dropdown-toggle category-toggle-son3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <Translate value="action" />
                              </button>
                              <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                <button
                                  type="button"
                                  className="dropdown-item dropdown-table"
                                  onClick={() => this.updateCategory(sub, subCategory)}
                                >
                                  <Translate value="edit" />
                                </button>

                                <button
                                  type="button"
                                  className="dropdown-item dropdown-table"
                                  onClick={() => this.removeCategory(sub.id)}
                                >
                                  <Translate value="delete" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  })

  render() {
    const {
      show, message, classe, showModal,
      selectedItem,
      titleModal,
      bodyModal,
      titleOkButtoonModal,
      widthModal,
      heightModal,
      idModal,
      showCancel,
      showModalFeatured,
      showModalOrderCategory,
      showChangeCategoryStatusModal,
    } = this.state;
    const { settings = {} } = this.props;
    const { companyTag = '' } = settings;

    return (
      <div className="main-table">
        {showModal && (
          <ModalComponent
            title={titleModal}
            body={bodyModal}
            visible={showModal}
            closeModal={() => this.setState({ showModal: false })}
            confirmModal={() => this.onModalConfirm()}
            titleOkButtoon={titleOkButtoonModal}
            size={{ width: widthModal, height: heightModal }}
            showButtons
            showCancel={showCancel}
            id={idModal}
            items={selectedItem}
          />
        )}
        {showChangeCategoryStatusModal && (
          <ModalComponent
            title={titleModal}
            body={bodyModal}
            visible={showChangeCategoryStatusModal}
            closeModal={() => this.setState({
              showChangeCategoryStatusModal: false,
              alterId: '',
              alterisActive: '',
              alterName: '',
            })}
            confirmModal={() => this.onChangeCategoryStatusConfirm()}
            titleOkButtoon={titleOkButtoonModal}
            size={{ width: widthModal, height: heightModal }}
            showButtons
            showCancel={showCancel}
            id={idModal}
            items={selectedItem}
          />
        )}
        <h2 className="header-form-client"><Translate value="categories" /></h2>
        <button
          type="button"
          className="btn btn-secondary margin-bottom-20 margin-left-10"
          onClick={() => this.props.history.push({
            pathname: ROUTES.FORM,
            screenComming: 'category',
          })}
        >
          <Translate value="register" />
        </button>
        <button
          type="button"
          className="btn btn-secondary margin-bottom-20 margin-left-10"
          onClick={() => this.props.history.push({
            pathname: ROUTES.UPLOAD_CATEGORIES,
            screenComming: 'category',
          })}
        >
          <Translate value="import" />
        </button>
        <button
          onClick={() => this.props.getCsvCategoriesReport()}
          type="button"
          className="btn btn-secondary margin-bottom-20 margin-left-10"
        >
          <Translate value="export" />
        </button>
        {this.props.categories && this.getCategories(this.props.categories)}
        {show && (
          <Notification
            classe={classe}
            message={message}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCategories: () => dispatch(getCategoriesAction()),
  removeCategory: id => dispatch(removeCategoryAction(id)),
  getCsvCategoriesReport: () => dispatch(getCsvCategoriesReport()),
  updateCategory: category => dispatch(updateCategoryAction(category)),
  updateCategories: categories => dispatch(updateCategoriesAction(categories)),
  disableProductsByCategory: categoryId => dispatch(disableProductsByCategory(categoryId)),
  updateCategoryStatus: categoryId => dispatch(updateCategoryStatus(categoryId)),
});

const mapStateToProps = state => ({
  categories: state.categories.categories,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryPage);
